const getUsersState = (state) => state && state.users ? state.users : {};
export const userList = (state) => getUsersState(state).userList;
export const createDialogOpen = (state) => getUsersState(state).createDialogOpen;
export const updateDialogOpen = (state) => getUsersState(state).updateDialogOpen;
export const username = (state) => getUsersState(state).username;
export const role = (state) => getUsersState(state).role;
export const organizationId = (state) => getUsersState(state).organizationId;
export const saveUserError = (state) => getUsersState(state).saveUserError;
export const isLoading = (state) => getUsersState(state).isLoading;
export const resetPasswordSuccess = (state) => getUsersState(state).resetPasswordSuccess;
export const userForm = (state) => getUsersState(state).userForm;
